'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { GroupMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import { MentoringCard } from '../../_components/MentoringCard';
import { GroupMentoringGoalPaths } from './GroupMentoringGoalPaths';
import { GroupMentoringOptions } from './Options';
export type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
export function getDefaultGroupProduct(subscription: Subscription): GroupMentoringProductDTO {
  return {
    order: ORDER_TYPE.GROUP_MENTORING,
    subscription,
    email: '',
    name: 'Mentoring podstawowy',
    quantity: 1
  };
}
export function GroupMentoring(t0) {
  const $ = _c(4);
  const {
    goalPage
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GroupMentoringOptions />;
    t2 = <GroupMentoringGoalPaths />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== goalPage) {
    t3 = <MentoringCard title="Mentoring podstawowy" details={"Dla os\xF3b, kt\xF3re chc\u0105 i\u015B\u0107 sprawdzon\u0105 drog\u0105 do celu z\xA0pomoc\u0105 mentora, korzystaj\u0105c z\xA0pe\u0142nej oferty naszych kurs\xF3w grupowych, asysty AI i\xA0wsparcia ambitnej spo\u0142eczno\u015Bci w\xA0jednym miejscu."} goalPage={goalPage}>{t1}{t2}</MentoringCard>;
    $[2] = goalPage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}